/* eslint-disable no-console */
/* eslint-disable prefer-template, max-len */
import _ from 'lodash';
import appConfig from 'application-config';
import debug from 'debug';

import { Responsive } from 'common/components';
import { SHARE_CONSTANTS } from 'client/constants';

const log = debug('app:client:share');

/**
 * Share buttons event handler
 *
 * @param {{}} options
 * @param {String} options.type
 * @param {String} options.mail
 * @param {String} options.img
 * @param {String} options.title
 * @param {String} options.description
 * @param {Function} cb
 */
export function share(options, cb = _.noop) {
	const defaultOptions = {
		type: '',
		mail: '',
		title: document.querySelector('meta[property="og:title"]').getAttribute('content'),
		description: document.querySelector('meta[property="og:description"]').getAttribute('content'),
		url: `${document
			.querySelector('meta[property="og:url"]')
			.getAttribute('content')}?utm_source=Email%26utm_medium=Share`,
		img: document.querySelector('meta[property="og:image"]').getAttribute('content'), // 1200x630
	};

	const currentOptions = Object.assign({}, defaultOptions, options);
	const { type, title, description, url, img, choiceId } = currentOptions;
	const encode = encodeURIComponent;
	const emailTitle = title;
	const emailText = '';
	const whatsAppText = `${title}\n${description}`;

	log('share options %O', currentOptions);

	if (type === SHARE_CONSTANTS.MAIL) {
		const domain = choiceId ? `${_.get(appConfig, 'domains.client.hostname', '')}#/choice/${choiceId}` : url;

		if (Responsive.isMatching(Responsive.DESKTOP)) {
			window.location.href =
				'mailto:?subject=' +
				encode(emailTitle) +
				'&body=' +
				encode(emailText) +
				'%0D%0A' +
				encode(description + ' ') +
				'%0D%0A%0D%0A' +
				encode(domain);
		} else {
			window.location.href =
				'mailto:?subject=' +
				encode(emailTitle) +
				'&body=' +
				encode(emailText) +
				'\n' +
				encode(description + ' ') +
				'\n\n' +
				encode(domain);
		}
	}

	if (type === SHARE_CONSTANTS.FACEBOOK) {
		const fbURL = 'https://www.facebook.com/sharer.php?u=';
		const domain = `${_.get(appConfig, ['domains', 'client', 'hostname'], 'NO HOSTNAME')}`;
		let finalURL;

		if (choiceId) {
			finalURL = `${fbURL}${encode(`${domain}/share/fb?choiceId=${choiceId}`)}`;
		} else {
			finalURL = `${fbURL}${encode(`${domain}/share/fb`)}`;
		}

		window.open(finalURL, 'sharer', 'width=555,height=600');
	}

	if (type === SHARE_CONSTANTS.WHATSAPP) {
		const hostMain = choiceId
			? `${_.get(appConfig, 'domains.client.hostname', '')}#/choice/${choiceId}`
			: _.get(appConfig, 'domains.client.hostname', '');
		const urlWhatsapp = `${hostMain}`;

		if (Responsive.isMatching(Responsive.DESKTOP)) {
			window.open(
				`https://web.whatsapp.com/send?text=${encode(`${whatsAppText}\n${urlWhatsapp}`)}&img="${encode(img)}"`,
				'_blank'
			);
		} else {
			window.location.href =
				'whatsapp://send?text=' + encode(`${whatsAppText}\n${urlWhatsapp}\n${choiceId ? hostMain : ''}`);
		}
	}

	if (type === SHARE_CONSTANTS.TWITTER) {
		const twURL = 'https://twitter.com/intent/tweet?url=';
		const domain = `${_.get(appConfig, ['domains', 'client', 'hostname'], 'NO HOSTNAME')}`;
		const finalURL = `${twURL}${encode(`${domain}/share/fb`)}?text=${encode(title + '\n' + description + '\n')}`; // WORKING

		const shareWindow = window.open(finalURL, 'ShareOnTwitter', 'width=555,height=600');
		shareWindow.opener = null;
	}

	cb();
}
